import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'weekDayPipe' })
export class WeekDayPipe implements PipeTransform {
    public transform(day: string): string {
        switch (day) {
            case 'monday': {
                return 'WEEK_DAYS.MONDAY';
            }
            case 'tuesday': {
                return 'WEEK_DAYS.TUESDAY';
            }
            case 'wednesday': {
                return 'WEEK_DAYS.WEDNESDAY';
            }
            case 'thursday': {
                return 'WEEK_DAYS.THURSDAY';
            }
            case 'friday': {
                return 'WEEK_DAYS.FRIDAY';
            }
            case 'saturday': {
                return 'WEEK_DAYS.SATURDAY';
            }
            case 'sunday': {
                return 'WEEK_DAYS.SUNDAY';
            }

            default: {
                return 'UNKNOWN';
            }
        }
    }
}
